import * as API from '@/api'
import request from './index'

//获取卡口列表
export function getListNp(params) {
    return request.get(API.KA_LIST_NP, {
        params
    })
}

//获取卡口列表
export function getList(params) {
    return request.get(API.KA_LIST, {
        params
    })
}

//添加厂区
export function add(data) {
    return request.post(API.KA_ADD, data)
}

//修改厂区
export function edit(data) {
    return request.post(API.KA_EDIT, data)
}

//删除厂区
export function del(id) {
    return request.get(API.KA_DEL, {
        params: {
            id
        }
    })
}
